import { useSelector } from 'react-redux';
import { AppState } from '../..';
import { SearchDataItem } from '../../logic/domains/search.domain';
import { SearchState } from '../../store/reducers/search.reducer/search.reducer';
import { AdviserDetails } from '../../type-definitions/redux-declarations';

const useAdviserDetails = (): AdviserDetails => {
	return useSelector((state: AppState) => state.adviser.adviserDetails);
};

const useSearchData = (): Array<SearchDataItem> => {
	return useSelector((state: AppState) => state.search.searchData);
};

const useSearchResults = (): SearchState => {
	return useSelector((state: AppState) => state.search);
};

const useRouterLocation = () => {
	return useSelector((state: AppState) => state.location);
};

const useRecentClients = () => {
	return useSelector((state: AppState) => state.recentClients);
};

export {
	useAdviserDetails,
	useSearchData,
	useSearchResults,
	useRouterLocation,
	useRecentClients,
};
